export const supportPage = {
  heading: 'support-page-heading',
  supportTiles: 'support-page-tile-link',
};
